import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
    moduleIds,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
} from "client/components"

const Markov = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        markovModuleAccess,
    } = settings

    return (
        <Collapse
            show={show}
            title={moduleList[moduleIds.markov].name}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.markovModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={markovModuleAccess === NO}
                            onChange={() => onChange({ markovModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={markovModuleAccess === YES}
                            onChange={() => onChange({ markovModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Markov
